
// @ts-nocheck





import { i18nText } from '@/locales';



import {Component, Vue} from 'vue-property-decorator';
import {mixins} from "vue-class-component";
import PageTitle from '@/UI/components/common/PageTitle.vue';
import FormGroup from "@/UI/components/common/form/FormGroup.vue";
import {message} from "ant-design-vue";
import NewsUpdateForm from "@/UI/components/forms/settings/news/NewsUpdateForm.vue";
import ClientsUpdateForm from "@/UI/components/forms/settings/categories/ClientsUpdateForm.vue";
import {SourcesStore} from '@/store/modules/Sources';
import {ISources} from '@/entity/sources/sources.types';
import ClientsCategoriesUpdateForm from "@/form/Settings/categories/clientsUpdate";
import {SourceCategoriesForm} from '@/UI/pages/Settings/Source/lib/sourceForm'
import {colorsSource} from '@/UI/pages/Settings/Source/lib/colors'
import {showNotificationSimple} from "@/UI/lib/messages";

import {
  Modal,
} from "ant-design-vue";




@Component({
  components: {
    PageTitle, FormGroup, NewsUpdateForm
  }
})
export default class Source extends mixins(colorsSource) {

  form = new SourceCategoriesForm()
  modal_title = i18nText("Новый источник")
  modal_window = false
  openPop = false
  openPopChange = false
  update_modal_form: boolean = false;
  updateForm = new ClientsCategoriesUpdateForm();
  colorsToPick: Array<Record<string, any>> = [];

  showDeleteForm(item: any): void {
    let thisRef = this;

    Modal.confirm({
      onOk: (): void => {
        let sourceHasClients = item.clients.length > 0;
        if (!sourceHasClients) {
          SourcesStore.delete(item.id).then((response) => {

            thisRef.$forceUpdate();
            SourcesStore.fetchAll();
            // thisRef.clientsCategories.data = SourcesStore.fetchAll();
            showNotificationSimple(response.data.response);
          });
        } else {
          showNotificationSimple(i18nText("Запрещено"), i18nText("Нельзя удалить категорию если к ней привязан(ы) клиент(ы)!"), 5);
        }
        Modal.destroyAll();
      },
      onCancel: (): void => {
        Modal.destroyAll();
      },

      autoFocusButton: "true",
      content: i18nText("Вы точно хотите удалить эту категорию?"),
      okText: i18nText("Да"),
      cancelText: i18nText("Нет"),
    });

  }

  pickColor(pc: any) {
    this.openPop = false;
    this.form.color = pc.link;
  }

  pickColorChange(pc: any) {

    this.openPopChange = false;
    this.updateForm.color = pc.link
  }

  filterColors(inputVal: string) {
    let temp = new colorsSource;
    this.colorsToPick = temp.colors.filter((color: any) => {
      // if (e.data === null) return true; // if empty filtering query return all (no filtering);

      return !!color.name.toString().match(new RegExp(inputVal, 'gmi'));

    });
    this.$forceUpdate();
    let timeoutId = setTimeout(() => {
      this.$forceUpdate();
    }, 500);
  }

  get rules() {
    function validateColor(rule, color) {
      let isValid = (new colorsSource).colors.filter(element => element.link === color).length !== 0;
      rule.message = color === undefined || color == '' ? i18nText("Это поле обязательно для заполнения") : i18nText("Неизвестный цвет");
      return isValid;
    }
    return {
      color: [{ required: true, message: i18nText("Это поле обязательно для заполнения"),  trigger: 'change' }],
      name: [{ required: true, message: i18nText("Это поле обязательно для заполнения"), trigger: 'change' }],
    }

  };

  async updateClient(one, two): Promise<void> {
    console.log('++++++++++++++++++++1676931168++++++++++++++++++++++++');console.log('this.updateForm : ' + (typeof this.updateForm));console.log(this.updateForm);console.log('--------------------1676931168------------------------');

    // if((this.updateForm.name && this.updateForm.color) ? :){

      if (await this.updateForm.submit(SourcesStore.update)) {
        this.update_modal_form = false;
        await SourcesStore.fetchAll();
      }
    // }
  }

  async showUpdateForm(item: any) {
    this.updateForm = new ClientsCategoriesUpdateForm();
    this.updateForm.setFormData(item);
    this.update_modal_form = true;
    this.filterColors('');
  }

  async createSource(): Promise<void> {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    await SourcesStore.create(this.form).then((response) => {
      message.success(response.response);
    })
    await this.getData()
    this.modal_window = false

  }

  async getData(): Promise<void> {
    await SourcesStore.fetchAll();
  }

  async created(): Promise<void> {
    try {
      let temp = new colorsSource;
      this.colorsToPick = temp.colors;
      await this.getData()
      this

    } catch (e) {
      console.error(e)
    }
  }

  get source(): ISources[] {
    return SourcesStore.sources
  }

}
